import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import OperatingHours from "./operatinghours";
import { Link, useNavigate } from "react-router";
import DataTable from "react-data-table-component";
import EditClinic from "./edit-clinic";
import AddRecruiter from "../recruiters/add-recruiter";
import Header from "../common/header/Header";
import { customStyles } from "../common/styling/constants";
import SecondaryButton from "../common/buttons/SecondaryButton";
import PdfExport from "./export-pdf";
import ExcelExport from "./export-excel";
import { IconSortyBy } from "../../assets/icons/icon-sortby-arrow";
import { IconExportArrow } from "../../assets/icons/icon-export-arrow";
import { IconExportDownload } from "../../assets/icons/icon-export-download";
import { IconViewDetail } from "../../assets/icons/icon-details";
import { IconEdit } from "../../assets/icons/icon-edit";
import { IconViewDetailHovered } from "../../assets/icons/icon-view-detail-hover";
import { IconEditHovered } from "../../assets/icons/icon-edit-hover";
import { formatPhoneNumber } from "../common/constant/constant";
import GetOpHours from "./read-operating-hours";
import { CustomPagination } from "../common/custom-pagination/custom-pagination";
import PatientsNoRecord from "../../assets/icons/patients-no-record";
import NoRecord from "../common/no-record/no-record";
import LocationNoRecord from "../../assets/icons/location-no-record";


const Clinicinfo = () => {
    const [mainClinicInfo, setMainClinicInfo] = useState([]);
    const [clinicInfo, getClinicInfo] = useState([]);
    const [showClose, setShowClose] = useState(false)
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("")
    const dropdownRefExport = useRef({});
    

    // hoverIcons
    const [isEditHovered, setIsEditHovered] = useState(null);
    const [isViewHovered, setIsViewHovered] = useState(null);

    const onSearchClick = () => {
        if (!search) {
            return
        }

        const lowerCaseSearchTerm = search.toLowerCase();

        const searchedValue = mainClinicInfo.filter((item) => {
            return (
                item.name.toLowerCase().includes(lowerCaseSearchTerm) ||
                item.address.toLowerCase().includes(lowerCaseSearchTerm) ||
                item.principalInvestigator.toLowerCase().includes(lowerCaseSearchTerm) ||
                item.phoneNumber.toLowerCase().includes(lowerCaseSearchTerm)
            );
        });

        getClinicInfo(searchedValue)
        setShowClose(true)
    }

    const onCloseClick = () => {
        getClinicInfo([...mainClinicInfo]);
        setSearch("")
        setShowClose(false)
    }

    // const navigate = useNavigate();
    const goToLogin = () => {
        navigate("/login");
    };

    // for sorting ------------------------------------------

    const [sortOrder, setSortOrder] = useState('desc');

    const handleSort = async (sortType, data) => {
        setSortOrder(sortType)
        if (sortType === 'asc') {
            const oldest = data && data.length ? [...data].sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateA - dateB;
            }) : [...clinicInfo].sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateA - dateB;
            });
            getClinicInfo(oldest)
        } else if (sortType === 'desc') {
            const newest = data && data.length ? [...data].sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateB - dateA;
            }) : [...clinicInfo].sort((a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);
                return dateB - dateA;
            });
            getClinicInfo(newest)
        }
    }

    // for sorting ENDS ------------------------------------------
    

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await axios.get(ENDPOINTS.CLINIC.CLINIC_INFO)

            const response = result.data.data;
            handleSort(sortOrder,response)
            // getClinicInfo(response);
            setMainClinicInfo(response)
            setLoading(false);

        } catch (error) {
          
        } finally {
            setLoading(false); // Set loading to false after the API call
        }
    }

    useEffect(() => {
        fetchData()
    }, []);

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

    // for popup
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const clinicListColumns = [
        {
            name: "Location Name",
            selector: (row) => row.firstName,
        },
        {
            name: "Location",
            selector: (row) => row.address,
            width: "300px"
        },
        {
            name: "Prinicipal Investigator",
            selector: (row) => row.principalInvestigator,
            width: "300px"
        },
        {
            name: "Contact",
            selector: (row) => formatPhoneNumber(row.phoneNumber),
            width: "150px"
        },
        {
            name: " ",
            selector: (row) => (
                <div className="flex item-center justify-end w-full">
                    <div>
                        <button
                            onClick={() => handleViewClick(row)}
                            title="View"
                            className="px-[20px]"
                            onMouseEnter={() => setIsViewHovered(row.id)}
                            onMouseLeave={() => setIsViewHovered(null)}
                        >
                            {isViewHovered === row.id ? <IconViewDetailHovered /> : <IconViewDetail />}

                        </button>
                        <button
                            onClick={() => handleEditClinic(row.id, row)}
                            title="Edit"
                            onMouseEnter={() => setIsEditHovered(row.id)}
                            onMouseLeave={() => setIsEditHovered(null)}
                        >
                            {isEditHovered === row.id ? <IconEditHovered /> : <IconEdit />}
                        </button>
                    </div>

                </div>
            ),
            width: "140px"
        }
    ]

    const clinicListColumnsColumnsData = clinicInfo?.map(
        (cl) => {

            const operatingHoursString = GetOpHours({ operatingHours: cl.operatingHoursJson })

            return {
                id: cl.clinicalInfoID,
                firstName: cl.name,
                operatingHours: operatingHoursString,
                phoneNumber: `+1 ${cl.phoneNumber}`,
                principalInvestigator: cl.principalInvestigator,
                timezone: cl.timezone.displayName,
                address: cl.address,
                countryName: cl.countryName,
                stateName: cl.stateName,
                city: cl.city,
                zip: cl.zip,
                smsFromNumber: cl.smsFromNumber
            }
        }
    )

    let navigate = useNavigate();

    const handleEditClinic = (id, data) => {
        navigate("/edit-location", { state: { id, data } });
    }

    const handleViewClick = (row) => {
        setSelectedRow(row);
        setIsOpen(true);
    };

    const closePopup = () => {
        setIsOpen(false);
        setSelectedRow(null);
    };

    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const handleToggleDropdown = () => {
        setDropdownVisible((prevState) => !prevState);
    };

    // Pagination
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [currentPageData, setCurrentPageData] = useState(clinicListColumnsColumnsData.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage));

    useEffect(() => {
        const indexOfLastItem = (currentPage + 1) * rowsPerPage;
        const indexOfFirstItem = indexOfLastItem - rowsPerPage;
        setCurrentPageData(clinicInfo.slice(indexOfFirstItem, indexOfLastItem));
    }, [currentPage, rowsPerPage, clinicInfo]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerPageChange = (perPage) => {
        setCurrentPage(0)
        setRowsPerPage(perPage)
    }

    useEffect(() => {
        const handleClickOutside2 = (event) => {
            if (dropdownRefExport.current && !dropdownRefExport.current.contains(event.target)) {
                setDropdownVisible(false);

            }
        };

        document.addEventListener("click", handleClickOutside2);
        return () => {
            document.removeEventListener("click", handleClickOutside2);
        };
    }, [isDropdownVisible]);
    
    return (
        <>
            <Header headertitle="Locations" backbutton={false} showClose={showClose} isSearch={true} search={search} setSearch={setSearch} onSearchClick={onSearchClick} onCloseClick={onCloseClick} />

            <>
                <div className="main-body sub_header px-8 py-4">
                    <div className="flex justify-between">
                        <div className="flex">
                            <Link to="/add-location" className="btn-primary primary_btn mr-[20px]">
                                <svg class="h-5 w-5 mr-2 text-white-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />  <circle cx="8.5" cy="7" r="4" />  <line x1="20" y1="8" x2="20" y2="14" />  <line x1="23" y1="11" x2="17" y2="11" /></svg>
                                Add Location
                            </Link>
                            <div className="flex">
                                <div className="flex justify-between items-center w-full relative title_color">
                                    <div className="m-auto">Sort by:</div>
                                    <select onChange={(e) => handleSort(e.target.value)} value={sortOrder} className="focus:outline-none font-[500] appearance-none pl-[10px] pr-[20px]">
                                        <option value="desc" className="p-[20px] hover:bg-gray-200 cursor-pointer text-gray-700">Newest</option>
                                        <option value="asc" className="p-[20px] hover:bg-gray-200 cursor-pointer text-gray-700">Oldest</option>
                                    </select>
                                    <span className="transform -translate-y-1/2 pointer-events-none absolute mt-6 right-[-10px]">
                                        <IconSortyBy />
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="flex gap-5">
                            <CustomPagination
                                rowsPerPage={rowsPerPage}
                                rowCount={clinicListColumnsColumnsData.length}
                                onChangePage={handlePageChange}
                                currentPage={currentPage}
                                handlePerPageChange={handlePerPageChange}
                            //   setRowsPerPage={setRowsPerPage}
                            />
                            <div className="relative" ref={dropdownRefExport}>
                                {/* Export button */}

                                <button
                                    onClick={handleToggleDropdown}
                                    className="inline-flex items-center py-[10px] px-[20px] bg-white border border-[#245CEA] rounded-md font-semibold text-gray-800 shadow-sm hover:bg-gray-100 focus:outline-none focus:none focus:none focus:none"
                                >

                                    <IconExportDownload />
                                    <span className="pl-[10px]">Export</span>
                                    <span className="ml-2 text-xs text-gray-500">
                                        <IconExportArrow />
                                    </span>
                                </button>

                                {/* Dropdown with buttons */}
                                {isDropdownVisible && (
                                    <div className="p-dd flex flex-col text-left border-solid border  bg-white  border-[#D1D7DC] w-full rounded-lg absolute -left-5 mt-5" onClick={handleToggleDropdown}>
                                        <PdfExport name="PDF" icon={true} class="bg-red" tableData={currentPageData} columns={clinicListColumns} fileName="Locations-list-export" classes={'py-2.5 px-5 me-2 mb-0 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-none border border-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-0 text-left'} />
                                        <ExcelExport name="EXCEL" data={currentPageData} containerClass={'py-[1px]'} classes={'py-2.5 px-5 me-2 mb-0 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-none border border-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-0 text-left  w-full'} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {loading ? <div class="spinnerwrapper"><div class="spinner"></div></div> : clinicListColumnsColumnsData && clinicListColumnsColumnsData.length ? <div className="main-body p-8">
                    <div className="mt-1">
                        <DataTable
                            columns={clinicListColumns}
                            data={clinicListColumnsColumnsData.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage)}
                            customStyles={customStyles}
                            sortIcon={<span>⇵</span>}
                        // pagination
                        // paginationPerPage={perPage}
                        // paginationRowsPerPageOptions={[10, 25, 50]}
                        // paginationComponentOptions={paginationOptions}
                        // onChangePage={handlePageChange}
                        // highlightOnHover
                        />

                        {/* Modal Popup */}
                        {isOpen && selectedRow && (
                            <div className="fixed view-popup inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
                                <div className="bg-white rounded-lg shadow-lg max-w-md w-full px-[24px] pb-[24px] pt-1 relative">
                                    <h2 className="text-[18px] font-semibold py-4 border-b table_border mb-4 text-[#060427]">Location Details</h2>
                                    <p className="text_field_popup">
                                        <span>Location Name:</span> {selectedRow.firstName}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>Contact:</span> {formatPhoneNumber(selectedRow.phoneNumber)}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>Prinicipal Investigator:</span> {selectedRow.principalInvestigator}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>Time Zone:</span> {selectedRow.timezone}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>Operating Hours:</span> {selectedRow.operatingHours}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>Address:</span> {selectedRow.address}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>Country:</span> {selectedRow.countryName}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>State:</span> {selectedRow.stateName}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>City:</span> {selectedRow.city}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>Zip:</span> {selectedRow.zip}
                                    </p>
                                    <p className="text_field_popup">
                                        <span>AI SMS Number (Twilio):</span> {selectedRow.smsFromNumber}
                                    </p>
                                    <button onClick={closePopup} className="btn-primary-base-bar primary_btn mt-[24px]" >Close</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div> : <NoRecord classes={"pt-7 px-7"} svg={LocationNoRecord} message={"No location records available at the moment."} />}
            </>

        </>
    )

}

export default Clinicinfo;